import React from "react";
import { useTranslation } from "react-i18next";
import { Profile } from "../../../types/types";
import { formatAlltext, formatText } from "../../../utils/formatUtils";

interface FightHistoryProps {
    member: Profile;
}

const FightHistory: React.FC<FightHistoryProps> = ({ member }) => {
    const { t } = useTranslation('publicProfile');
    if (!member.fighter) return null;

    return (
        <div className="space-y-4 pb-8">
            <h3 className="text-base font-semibold text-gray-800 border-b pb-2 text-start">
                {t("fight_history")}
            </h3>
            <div className="space-y-4">
                {member.fighter.fightHistories?.length ? (
                    <div className="overflow-x-auto">
                        <table className="w-full border-collapse border border-gray-300">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 px-4 py-2 text-left text-xs font-medium text-gray-600">
                                        {t("opponent")}
                                    </th>
                                    <th className="border border-gray-300 px-4 py-2 text-left text-xs font-medium text-gray-600">
                                        {t("date")}
                                    </th>
                                    <th className="border border-gray-300 px-4 py-2 text-left text-xs font-medium text-gray-600">
                                        {t("result")}
                                    </th>
                                    <th className="border border-gray-300 px-4 py-2 text-left text-xs font-medium text-gray-600">
                                        {t("round")}
                                    </th>
                                    <th className="border border-gray-300 px-4 py-2 text-left text-xs font-medium text-gray-600">
                                        {t("location")}
                                    </th>
                                    <th className="border border-gray-300 px-4 py-2 text-left text-xs font-medium text-gray-600">
                                        {t("organization")}
                                    </th>
                                    <th className="border border-gray-300 px-4 py-2 text-left text-xs font-medium text-gray-600">
                                        {t("type_of_ending")}
                                    </th>
                                    <th className="border border-gray-300 px-4 py-2 text-left text-xs font-medium text-gray-600">
                                        {t("rule_set")}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {member.fighter.fightHistories.map((fight: any) => (
                                    <tr key={fight.id} className="hover:bg-gray-50">
                                        <td className="border border-gray-300 px-4 py-2 text-sm font-medium text-gray-900">
                                            {formatText(fight.opponentName)}
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2 text-sm font-medium text-gray-900">
                                            {new Date(fight.date).toLocaleDateString()}
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2 text-sm font-medium text-gray-900">
                                            {formatText(fight.result)}
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2 text-sm font-medium text-gray-900">
                                            {formatText(fight.round)}
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2 text-sm font-medium text-gray-900">
                                            {formatText(fight.location)}
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2 text-sm font-medium text-gray-900">
                                            {formatText(fight.organizationName)}
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2 text-sm font-medium text-gray-900">
                                            {formatAlltext(fight.typeOfEnding?.toString())}
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2 text-sm font-medium text-gray-900">
                                            {formatAlltext(fight.preferredRuleSet?.toString())}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p className="text-gray-500 text-center py-8">
                        {t("no_fight_history")}
                    </p>
                )}
            </div>
        </div>
    );
};

export default FightHistory;
